/** 影视剧分镜表 · 景别 / 机位 / 运镜 选项 */

export const SHOT_SIZE_OPTIONS = [
  '大特写',
  '特写',
  '中近景',
  '中景',
  '中全景',
  '全景',
  '远景',
  '过肩',
  '主观',
] as const

/** 历史英文缩写 → 中文景别（只读展示兼容） */
const SHOT_SIZE_CODE_TO_ZH: Record<string, string> = {
  ECU: '大特写',
  CU: '特写',
  MCU: '中近景',
  MS: '中景',
  MLS: '中全景',
  LS: '全景',
  ELS: '远景',
  OTS: '过肩',
  POV: '主观',
}

export function formatShotSize(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return ''
  const upper = trimmed.toUpperCase()
  return SHOT_SIZE_CODE_TO_ZH[upper] ?? trimmed
}

export function normalizeShotSize(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return ''
  const upper = trimmed.toUpperCase()
  return SHOT_SIZE_CODE_TO_ZH[upper] ?? trimmed
}

export const CAMERA_ANGLE_OPTIONS = [
  '平',
  '俯',
  '仰',
  '侧',
  '过肩',
  '主观',
  '鸟瞰',
  '低机位',
] as const

export const CAMERA_MOVEMENT_OPTIONS = [
  '固定',
  '推',
  '拉',
  '摇',
  '移',
  '跟',
  '升',
  '降',
  '甩',
  '变焦',
  '手持',
  '环绕',
] as const

export type ShotSizeOption = (typeof SHOT_SIZE_OPTIONS)[number]
export type CameraAngleOption = (typeof CAMERA_ANGLE_OPTIONS)[number]
export type CameraMovementOption = (typeof CAMERA_MOVEMENT_OPTIONS)[number]
